import {
  stationaryConsoleList,
  IStationaryConsoleListResponseOK,
  IStationaryConsoleListParameters,
} from '@ifit/gateway-console-store';
import { useQuery, UseQueryResult } from 'react-query';
import { FIFTEEN_SECONDS, ONE_DAY } from '../../util/durations';

export function useStationaryConsoleList(
  softwareNumber: string,
  equipmentType: string
): UseQueryResult<IStationaryConsoleListResponseOK, Error> {
  const parameters: IStationaryConsoleListParameters = {
    limit: 1,
    softwareNumber,
  };

  return useQuery<IStationaryConsoleListResponseOK, Error>(
    ['use-stationary-console', { softwareNumber }],
    () =>
      stationaryConsoleList({
        useBasicAuth: true,
        ...parameters,
      }),
    {
      staleTime: FIFTEEN_SECONDS,
      cacheTime: ONE_DAY,
      enabled: equipmentType === 'run',
    }
  );
}
